<div class="image-annotation-component w-100" [class.private]="privateCondition != null">
  @if (isLoading) {
    <div class="image-annotation-loading-overlay" role="status" [attr.aria-label]="'loading' | translate">
      <mtm-loading-spinner [label]="'Loading image...'" [textColor]="'white'" />
    </div>
  }
  @if (isFullscreen) {
    <div class="image-viewer-fullscreen-backdrop" aria-hidden="true"></div>
  }
  @if (!hideTopMediaInfo && !isFullscreen) {
    <ng-container [ngTemplateOutlet]="topMediaTemplate"></ng-container>
  }
  <div
    class="image-outer-container col d-flex flex-column align-items-center justify-content-center positive-relative media-container image-outer-container--without-comment-bar"
    [class.fullscreen]="isFullscreen"
    [class.release-preview]="isReleasePreview"
    [class.share-link-preview]="isShareLinkPreview">
    <div class="image-inner-container">
      <!-- <img #imageAsset class="image-main" id="test" [src]="item.signedURL" alt=""> -->
      <div class="vac-canvas-d" [ngClass]="{ active: imageHandler?.isImageMovable }" #resizeDiv>
        <canvas id="canvas-fabric-image-{{ instanceId }}"></canvas>
      </div>
    </div>
    @if (isFullscreen) {
      <button
        type="button"
        class="image-viewer-exit-fullscreen-btn"
        [attr.aria-label]="'Exit fullscreen' | translate"
        (click)="toggleFullscreenForViewer()">
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true">
          <path
            d="M6.12154 5.4081V1.13833C6.12154 0.74499 5.80325 0.4267 5.40991 0.4267C5.01657 0.4267 4.69828 0.74499 4.69828 1.13833V3.69018L1.21658 0.208486C1.0776 0.0694979 0.895518 -1.89371e-07 0.713441 -2.05289e-07C0.531363 -2.21207e-07 0.349288 0.0694978 0.210299 0.208486C-0.0676765 0.486462 -0.0676775 0.936794 0.210299 1.21477L3.69199 4.69647H1.14014C0.746801 4.69647 0.428512 5.01476 0.428512 5.40809C0.428512 5.80143 0.746801 6.11972 1.14014 6.11972H5.40991C5.80325 6.11972 6.12154 5.80143 6.12154 5.4081ZM13.8077 8.82447C13.8077 9.21781 13.4894 9.5361 13.0961 9.5361H10.5442L14.0259 13.0178C14.3039 13.2958 14.3039 13.7461 14.0259 14.0241C13.7479 14.3021 13.2976 14.3021 13.0196 14.0241L9.53791 10.5424V13.0942C9.53791 13.4876 9.21962 13.8059 8.82628 13.8059C8.43295 13.8059 8.11466 13.4876 8.11466 13.0942L8.11466 8.82447C8.11466 8.43113 8.43295 8.11284 8.82628 8.11284L13.0961 8.11284C13.4894 8.11284 13.8077 8.43113 13.8077 8.82447Z"
            fill="currentColor" />
        </svg>
        <span class="image-viewer-exit-fullscreen-label">{{ 'Exit fullscreen' | translate }}</span>
      </button>
    }
    @if (!isFullscreen) {
      <ng-container [ngTemplateOutlet]="assetListTemplate"></ng-container>
      <ng-container [ngTemplateOutlet]="assetInfoTemplate"></ng-container>
    }
  </div>
  @if (!isFullscreen) {
    <div
      #controlBar
      class="control-bar d-flex align-items-center justify-content-between pe-3 ps-2 py-2 my-2"
      [class.control-bar--compare-mode]="isCompareMode">
      <!-- LEFT: Annotation markers -->
      <div class="d-flex align-items-center control-bar-left">
        @if (filteredAnnotations().length <= MAX_MARKERS_TO_SHOW + 1) {
          @for (annotation of filteredAnnotations(); track annotation.id) {
            @if (!annotation.range?.isGeneralComment) {
              <div
                class="annotation-marker"
                [class.disabled]="!isAnnotationDisplayEnabled"
                [class.active]="isAnnotationActive(annotation)"
                [style.zIndex]="100 - $index">
                <mtm-user-profile-picture
                  [username]="annotation.comments[0].meta.user_id"
                  [height]="20"
                  [width]="20"
                  [showBorder]="false"
                  (mouseenter)="hoverInAnnotation(annotation)"
                  (mouseleave)="hoverOutAnnotation(annotation)"
                  (click)="annotationBarClick(annotation)">
                </mtm-user-profile-picture>
              </div>
            }
          }
        } @else {
          @for (annotation of visibleMarkerAnnotations(); track annotation.id) {
            <div
              class="annotation-marker"
              [class.active]="isAnnotationActive(annotation)"
              [class.disabled]="!isAnnotationDisplayEnabled"
              [style.zIndex]="100 - $index">
              <mtm-user-profile-picture
                [username]="annotation.comments[0].meta.user_id"
                [height]="20"
                [width]="20"
                [showBorder]="false"
                (mouseenter)="hoverInAnnotation(annotation)"
                (mouseleave)="hoverOutAnnotation(annotation)"
                (click)="annotationBarClick(annotation)">
              </mtm-user-profile-picture>
            </div>
          }
          <div ngbDropdown class="annotation-more-dropdown">
            <button
              type="button"
              class="viewer-controller-icon-btn annotation-more-toggle"
              [class.active]="isDropdownItemActive()"
              [class.disabled]="!isAnnotationDisplayEnabled"
              ngbDropdownToggle
              aria-haspopup="true"
              [attr.aria-label]="'More annotations'">
              +{{ annotationsForMoreDropdown().length }}
            </button>
            <div ngbDropdownMenu class="annotation-more-menu">
              @for (item of annotationsForMoreDropdown(); track item.annotation.id) {
                <button
                  type="button"
                  ngbDropdownItem
                  class="annotation-more-item"
                  [class.annotation-more-item-active]="isAnnotationActive(item.annotation)"
                  (mouseenter)="hoverInAnnotation(item.annotation)"
                  (mouseleave)="hoverOutAnnotation(item.annotation)"
                  (click)="annotationBarClick(item.annotation)">
                  <span class="annotation-more-item-avatar">
                    <mtm-user-profile-picture
                      [username]="item.annotation.comments[0].meta.user_id"
                      [height]="20"
                      [width]="20"
                      [showBorder]="false">
                    </mtm-user-profile-picture>
                  </span>
                  <span class="annotation-more-item-label">
                    {{ getCommentBodyPreview(item.annotation.comments[0].body, 12) }}
                  </span>
                </button>
              }
            </div>
          </div>
        }
      </div>
      <!-- RIGHT: Controls -->
      <div class="d-flex align-items-center control-bar-right">
        <viewer-reject-button></viewer-reject-button>
        <viewer-approve-button></viewer-approve-button>
        <viewer-compare-button
          [projectId]="projectId || item?.projectId"
          [sectionId]="sectionId || item?.sectionId"
          [subsectionId]="subsectionId || item?.subSectionId"
          [optionId]="typeId || item?.optionId || item?.itemId"
          [versionNumber]="item?.versionNumber"
          [fileId]="item?.id"></viewer-compare-button>
        @if (!controlBarIsNarrow) {
          <mtm-file-download-control
            [file]="item"
            displayType="icon"
            #downloadButton
            [iconSize]="18"
            [lightIcon]="true"
            [iconColor]="'#b0b0b0'"
            [uniqueControlId]="`${item.projectId}-${item.sectionId}-${item.subSectionId}-${item.id}`">
          </mtm-file-download-control>
        }
        <viewer-info-button [file]="file"></viewer-info-button>
        <viewer-annotation-toggle-button [isActive]="isAnnotationDisplayEnabled" (clicked)="toggleAnnotationDisplay()">
        </viewer-annotation-toggle-button>
        <div class="slider-wrapper d-flex align-items-center">
          <input
            type="range"
            [min]="zoomRange.min"
            [max]="zoomRange.max"
            [ngModel]="imageZoom"
            (ngModelChange)="setImageZoom($event)"
            step="1"
            class="slider-custom" />
          <div
            class="zoom-dropdown-wrapper"
            ngbDropdown
            placement="top"
            container="body"
            #zoomDrop="ngbDropdown"
            (openChange)="onZoomDropdownOpen($event)">
            <button
              type="button"
              class="zoom-value-trigger"
              ngbDropdownToggle
              aria-haspopup="true"
              aria-label="Zoom level">
              <span class="zoom-value">{{ imageZoom | number: '1.0-0' }}%</span>
              <span class="zoom-caret" aria-hidden="true">
                <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0.690219 2.95508L3.5248 0.687415L6.35938 2.95508"
                    stroke="white"
                    stroke-width="1.37519"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </span>
            </button>
            <div ngbDropdownMenu class="zoom-dropdown-menu">
              <div class="zoom-dropdown-input-row" (click)="$event.stopPropagation()">
                <input
                  type="number"
                  class="zoom-input zoom-input-no-focus-outline"
                  [ngModel]="zoomInputValue"
                  (ngModelChange)="zoomInputValue = $event"
                  (keydown.enter)="applyZoomFromInput(); zoomDrop.close()"
                  (blur)="applyZoomFromInput()"
                  [attr.min]="zoomRange.min"
                  [attr.max]="zoomRange.max"
                  aria-label="Zoom percentage" />
                <span class="zoom-input-suffix">%</span>
              </div>
              <button type="button" class="zoom-dropdown-item" ngbDropdownItem (click)="setZoom(1); zoomDrop.close()">
                <span class="zoom-item-label">{{ 'zoom_in' | translate }}</span>
                <span class="zoom-item-shortcut">
                  <span>Ctrl+</span>
                </span>
              </button>
              <button type="button" class="zoom-dropdown-item" ngbDropdownItem (click)="setZoom(-1); zoomDrop.close()">
                <span class="zoom-item-label">{{ 'zoom_out' | translate }}</span>
                <span class="zoom-item-shortcut">
                  <span>Ctrl−</span>
                </span>
              </button>
              <button
                type="button"
                class="zoom-dropdown-item"
                ngbDropdownItem
                (click)="resetImageOrientation(); zoomDrop.close()">
                <span class="zoom-item-label">{{ 'zoom_to_fit' | translate }}</span>
                <span class="zoom-item-shortcut">
                  <img src="/assets/img/annotations/keyboard-shift.svg" alt="Fit" height="10" width="10" />
                  <span>1</span>
                </span>
              </button>
              <div class="zoom-dropdown-divider"></div>
              <button
                type="button"
                class="zoom-dropdown-item"
                ngbDropdownItem
                (click)="setImageZoom(50); zoomDrop.close()">
                <span class="zoom-item-label">{{ 'zoom_to_50' | translate }}</span>
              </button>
              <button
                type="button"
                class="zoom-dropdown-item"
                ngbDropdownItem
                (click)="setImageZoom(100); zoomDrop.close()">
                <span class="zoom-item-label">{{ 'zoom_to_100' | translate }}</span>
                <span class="zoom-item-shortcut">
                  <span>Ctrl0</span>
                </span>
              </button>
              <button
                type="button"
                class="zoom-dropdown-item"
                ngbDropdownItem
                (click)="setImageZoom(200); zoomDrop.close()">
                <span class="zoom-item-label">{{ 'zoom_to_200' | translate }}</span>
              </button>
            </div>
          </div>
          <button
            type="button"
            class="control-bar-fit-btn"
            [attr.data-tooltip]="'Fit to screen'"
            [attr.aria-label]="'Fit to screen'"
            [ngbTooltip]="isCompareMode ? 'Fit to screen' : null"
            [container]="isCompareMode ? 'body' : null"
            tooltipClass="image-annotation-fit-tooltip"
            placement="top"
            triggers="hover"
            (click)="resetImageOrientation()">
            {{ 'fit' | translate }}
          </button>
        </div>
        <viewer-slider-toggle-button [typeId]="typeId"></viewer-slider-toggle-button>
        @if (!controlBarIsNarrow) {
          <viewer-cinema-mode-button class="zoom-chevron"></viewer-cinema-mode-button>
          <viewer-fullscreen-button
            [active]="isFullscreen"
            (clicked)="toggleFullscreenForViewer()"></viewer-fullscreen-button>
        }
        @if (controlBarIsNarrow) {
          <div ngbDropdown class="control-bar-more-dropdown" container="body" placement="top">
            <button
              type="button"
              class="viewer-controller-icon-btn control-bar-more-toggle"
              ngbDropdownToggle
              aria-haspopup="true"
              [attr.aria-label]="'More' | translate">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <circle cx="8" cy="3" r="1.25" fill="currentColor" />
                <circle cx="8" cy="8" r="1.25" fill="currentColor" />
                <circle cx="8" cy="13" r="1.25" fill="currentColor" />
              </svg>
            </button>
            <div ngbDropdownMenu class="control-bar-more-menu">
              <div class="control-bar-more-menu-inner">
                <mtm-file-download-control
                  [file]="item"
                  displayType="icon"
                  #downloadButton
                  [iconSize]="18"
                  [lightIcon]="true"
                  [iconColor]="'#b0b0b0'"
                  [uniqueControlId]="`${item.projectId}-${item.sectionId}-${item.subSectionId}-${item.id}`">
                </mtm-file-download-control>
                <viewer-cinema-mode-button class="zoom-chevron"></viewer-cinema-mode-button>
                <viewer-fullscreen-button
                  [active]="isFullscreen"
                  (clicked)="toggleFullscreenForViewer()"></viewer-fullscreen-button>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
